







































import { Component, Vue, Watch } from 'vue-property-decorator';
import DemographicChart from '@/components/Charts/DemographicChart.vue';
import UnitGroupings from '@/ts/UnitGroupings';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component({
    components: {
        DemographicChart,
    },
})
export default class UnitGroupingCharts extends Vue {
    public activeGrouping: UnitGroupings = null;
    public charts: any = [
        { label: this.$t('general.age', 'Age'), mode: 'age' },
        { label: this.$t('general.gender', 'Gender'), mode: 'gender' },
        { label: this.$t('general.interests', 'Interests'), mode: 'socialClubs' },
        { label: this.$t('general.field-of-profession', 'Field of profession'), mode: 'educations' },
    ];

    constructor() {
        super();
    }

    @Watch('activeGrouping')
    public activeGroupingChanged() {
        this.fetchTenantsData();
    }

    get unitGroupings(): UnitGroupings {
        const groupings = this.$store.getters['Groupings/getUnitGroupings'];
        this.activeGrouping = groupings[0];

        return groupings;
    }

    get demographicTenants() {
        return this.$store.getters['UnitGroupingCharts/getUnitGroupingTenantsDemographicData'];
    }

    public fetchTenantsData() {
        this.$store.dispatch(Actions.FETCH_UNIT_GROUPING_TENANTS_DEMOGRAPHIC, this.activeGrouping.id);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_TENANTS_DEMOGRAPHIC_FLAYOUT_VISIBILITY, false);
    }
}
